<template>
  <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              v-model="dateFormatted"
              :label="label"
              v-bind="attrs"
              @blur="date = parseDate(dateFormatted)"
              clearable
              :readonly="textReadOnly"
              :class="inputClass"
              v-on="on"
              :rules="rules"
              :error-messages="errorMessages"
              autocomplete="off"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" :allowed-dates="alloweDates" :min="min" :max="max" no-title @input="menu = false;"></v-date-picker>
        </v-menu>  
</template>
<script>
export default {
    name:"DateInput",
    props:['value','label','rules','inputClass','alloweDates','min','max','formatFunction','textReadOnly'],
    data(){
        return{
            menu:false,
            date:null,
            dateFormatted:null,
            errorMessages:null
        }
    },
    watch: {
      date () {
        this.dateFormatted = this.formatDate(this.date);
        this.emitChange();
      },
      value(val) {
        if(!this.date && val){
          this.date = val
        }
      }
    },
    created(){
        if(this.value){
            this.date = this.value;
        }
        this.emitChange();
    },
    methods:{
        emitChange(){
            this.$emit("input",this.date)
        },
        formatDate (date) {
            if (!date) {
              return null;
            }
            if(this.formatFunction && this.formatFunction instanceof Function){
                return this.formatFunction(date);
            }
            if (date.indexOf('T') != -1){
              date = date.split('T')[0];
            }
            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
       },
      parseDate (date) {
            if (!date) {
               this.errorMessages = null;
                return null;
            }
            //only validate date if the text field is able to input
            if (!(this.formatFunction && this.formatFunction instanceof Function)){
              if(!this.validateDate(date)){
                  this.errorMessages = "Date is invalid."
                  return null;
              }else{
                  this.errorMessages = null;
              }
            }
            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      validateDate(dateString){
          // First check for the pattern
        if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)){
          return false;
        }
           

        // Parse the date parts to integers
        const parts = dateString.split("/");
        const day = parseInt(parts[1], 10);
        const month = parseInt(parts[0], 10);
        const year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12){
            return false;
        }

        const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)){
            monthLength[1] = 29;
        }

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
      }
    }
}
</script>
